// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3yrak","inputWrap":"Table_inputWrap__hEAgS","col":"Table_col__37vv4","bmiTooltip":"Table_bmiTooltip__3LDTn"};